import React from "react";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.title}>404</h1>
        <p style={styles.subtitle}>Oops! Page Not Found</p>
        <p style={styles.description}>
          Sorry, but the page you are looking for does not exist, has been
          moved, or is temporarily unavailable. Please check the URL or return
          to the homepage.
        </p>
        <button
          style={styles.button}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#2cabcb")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#51833a")}
          onClick={() => navigate("/")}
        >
          ⬅️ Go Home
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    // background: "linear-gradient(135deg, #2cabcb, #00c851)",
    textAlign: "center",
    padding: "20px",
  },
  content: {
    maxWidth: "600px",
    padding: "40px",
    borderRadius: "15px",
    backgroundColor: "#fff",
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
    animation: "fadeIn 0.8s ease-in-out",
  },
  title: {
    fontSize: "100px",
    fontWeight: "bold",
    color: "#51833a",
    marginBottom: "10px",
  },
  subtitle: {
    fontSize: "24px",
    fontWeight: "600",
    color: "#343a40",
  },
  description: {
    fontSize: "16px",
    color: "#6c757d",
    marginBottom: "20px",
  },
  button: {
    backgroundColor: "#51833a",
    color: "white",
    padding: "12px 24px",
    fontSize: "16px",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  },
};

export default NotFoundPage;
